// import icons
import { FaYoutube, FaInstagram, FaGithub } from 'react-icons/fa';
import { BsChatDotsFill } from 'react-icons/bs';

// import images
import AboutImg from '../src/assets/img/about1.png';
import Feature1Img from '../src/assets/img/features/feature11.png';
import Feature2Img from '../src/assets/img/features/feature21.png';
import Feature3Img from '../src/assets/img/features/feature31.png';
import Feature4Img from '../src/assets/img/features/feature41.png';
import LogoV2 from '../src/assets/img/logo12.png';
import HeroImage from '../src/assets/img/hero-img1.png';
import Feature1BgImg from '../src/assets/img/features/feature1_bg.png';
import Feature2BgImg from '../src/assets/img/features/feature2_bg.png';
import Feature3BgImg from '../src/assets/img/features/feature3_bg.png';
import Feature4BgImg from '../src/assets/img/features/feature4_bg.png';

export const navigationData = [
  {
    name: 'Home',
    href: '/',
  },
  {
    name: 'About',
    href: '#About',
  },
  {
    name: 'Services',
    href: '#Features',
  },
  {
    name: 'Contact',
    href: '#CtaSection',
  },
];

export const heroData = {
  title: `Be Your Own Guru`,
  subtitle:
    'Explore Books,PQYS,Coding contest alerts and Notifications from your college professors at a single click',
  btnText: 'Get Started',
  image: HeroImage,
};

export const aboutData = {
  image: AboutImg,
  title: 'Find Out A Little More About Us',
  subtitle:
    ' We are a Platform through which you can easily help yourself with a wide range of study resources such as reference books, Previous year question papers and Coding Contest alerts at all one place.Your Contribution to the material is highly Welcomed!!.',
};

export const featuresData = {
  title: 'Services We Offer',
  subtitle:
    'Explore all the resources for free!Study hard and be your own Guru when in need with help of GradGuru.Look for the app now!',
  list: [
    {
      image: Feature1Img,
      bgImage: Feature1BgImg,
      title: 'Reference Books',
      link:'/Book',
      description:
        'Reference books as well as Local Publication Books for Every subject Each Semester',
      linkText: 'Explore',
      delay: '200',
    },
    {
      image: Feature2Img,
      bgImage: Feature2BgImg,
      title: 'Previous Year Question Paper',
      link:'/Paper',
      description:
        'Question papers from all Previous Years All Subjects',
      linkText: 'Explore',
      delay: '500',
    },
    {
      image: Feature3Img,
      bgImage: Feature3BgImg,
      title: 'Coding Contest Alerts',
      link:'/CodingAlert',
      description:
        'Get Coding Contest Alerts from different Coding Platforms to improve your Coding Skills',
      linkText: 'Explore',
      delay: '800',
    },
    {
      image: Feature4Img,
      bgImage: Feature4BgImg,
      title: 'Professors Desk',
      link:'/Notification',
      description:
        'Get Notifications from your Professors so that you never miss any Submittion deadline',
      linkText: 'Explore',
      delay: '1000',
    },
  ],
};

export const ctaData = {
  title: 'Contact Us From Here',
  subtitle: 'Do us all the services and dont forget to give your feedback! ',
  btnText1: 'Email',
  btnText2:  'Instagram'
  
};

export const footerData = {
  logo: LogoV2,
  address: 'PES Modern College of Engineering, 1186/A, Off J.M. Road, Shivaji nagar,Pune, Maharashtra 411005',
  email: 'GradGuru@gmail.com',
  phone: '9999994444',
  list1: [
    {
      name: 'Home',
      href: '#',
    },
    {
      name: 'About',
      href: '#',
    },
    {
      name: 'Services',
      href: '#',
    },
    {
      name: 'Contact',
      href: '#',
    },
  ],
  list2: [
    {
      name: 'Contribute',
      href: '#',
    },
    {
      name: 'Email',
      href: '#',
    },
    {
      name: 'Contact',
      href: '#',
    },
    
  ],
  socialList: [
    {
      icon: <FaYoutube />,
      href: '#',
    },
    {
      icon: <FaInstagram />,
      href: '#',
    },
    {
      icon: <FaGithub />,
      href: '#',
    },
  ],
};

export const copyrightData = {
  text: '© GradeGuru All rights reserved.',
  icon: <BsChatDotsFill />,
};
